export const convertSecondsToMinutes = (timeInSeconds: number) => Math.ceil(timeInSeconds / 60);
